import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export function formatUtcDate(
  value: string | Date | null | undefined,
  format = 'MM/DD/YYYY',
): string {
  if (!value) {
    return '';
  }

  const date = dayjs.utc(value);

  return date.isValid() ? date.format(format) : '';
}

export function getDateTimestamp(
  value: string | Date | null | undefined,
): number {
  if (!value) {
    return 0;
  }

  const date = dayjs.utc(value);

  return date.isValid() ? date.valueOf() : 0;
}
